import { DealTypeContainer } from '../../containers/filters/DealTypeContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const dealType: IOpenableFilter = {
  component: DealTypeContainer,
  type: EFilterType.Openable,
};
